import { render } from "./PuntoPickMpio.vue?vue&type=template&id=a5f6b3b6"
import script from "./PuntoPickMpio.vue?vue&type=script&lang=ts"
export * from "./PuntoPickMpio.vue?vue&type=script&lang=ts"
script.render = render

export default script